import { Modal } from 'ant-design-vue'
import { reactive, ref } from 'vue'
import { apiRoutes } from '../infraestructure/apiRoutes'
import { buildQueryParameters, get, post, softDelete, update } from '../infraestructure/repository/generic.repository'

const useBusinessSetting = () => {

  // ****************************************************************
  // ****************************************************************
  // VARIABLES INITIALIZATION
  const searchText = ref('')
  const visible = ref(false)

  const formId = ref('')
  let form = reactive({
    name: '',
    street: '',
    place: '',
    district: '',
    municipality: '',
    state: '',
    zipCode: '',
    rfc: '',
    canacintraRegistration: '',
    cmic: '',
    status: true,
  })
  let formLoad = ref(false)
  const rules = {
    name: [{ required: true, message: 'La razón social es obligatorio' }],
    street: [{ required: true, message: 'La calle es obligatoria' }],
    place: [{ required: true, message: 'El lugar, la torre u edificio es obligatorio' }],
    district: [{ required: true, message: 'El municipio o delegación es obligatorio' }],
    state: [{ required: true, message: 'El estado es obligatorio' }],
    zipCode: [{ required: true, message: 'El código postal es obligatorio' }],
    rfc: [{ required: true, message: 'El RFC es obligatorio' }],
    canacintraRegistration: [{ required: true, message: 'El registro canacintra es obligatorio' }],
    cmic: [{ required: true, message: 'El CMIC es obligatorio' }],
  }

  // ERROR VARIABLES
  let errorHandler = reactive({
    errorDescription: {
      errors: [],
    },
    errorNumber: 0,
  })
  const ruleForm = ref(null)

  const businessSettings = ref([])
  const tableLoading = ref(false)
  // VARIABLES INITIALIZATION
  // ****************************************************************
  // ****************************************************************

  // ****************************************************************
  // ****************************************************************
  // MODAL FUNCTIONS
  const openModal = (data = null) => {
    console.log('openModal: ', { data });

    tableLoading.value = true
    visible.value = true
    if (formId.value !== '' && data) {
      const {
        name,
        street,
        place,
        district,
        municipality,
        state,
        zipCode,
        rfc,
        canacintraRegistration,
        cmic,
        status,
      } = data

      form.name = name
      form.street = street
      form.place = place
      form.district = district
      form.municipality = municipality
      form.state = state
      form.zipCode = zipCode
      form.rfc = rfc
      form.canacintraRegistration = canacintraRegistration
      form.cmic = cmic
      form.status = status
    }
    tableLoading.value = false
  }
  const closeModal = () => {
    visible.value = false
    reinitializeForm()
  }
  const reinitializeForm = () => {
    formId.value = ''
    form.name = ''
    form.street = ''
    form.place = ''
    form.district = ''
    form.state = ''
    form.zipCode = ''
    form.rfc = ''
    form.canacintraRegistration = ''
    form.cmic = ''
    form.status = true

    errorHandler.errorDescription.errors = []
    errorHandler.errorNumber = 0
  }
  // MODAL FUNCTIONS
  // ****************************************************************
  // ****************************************************************

  // ****************************************************************
  // ****************************************************************
  // EVENTS FUNCTIONS
  const eventOpenModal = (data) => {
    const { id } = data
    formId.value = id
    openModal(data)
  }

  const eventSoftDelete = (data) => {
    Modal.confirm({
      title: '¿Está seguro de eliminar este registro?',
      content: 'Está operación será irreversible, elija con precaución.',
      okText: 'Si, eliminar',
      okType: 'danger',
      cancelText: 'No',
      async onOk() {
        tableLoading.value = true

        const { id } = data
        formId.value = id
        await deleteRecord()
      },
      onCancel() {
      },
    })
  }
  // EVENTS FUNCTIONS
  // ****************************************************************
  // ****************************************************************

  const getBusinessSettings = async (limit = 10, page = 0) => {
    tableLoading.value = true

    const path = `${apiRoutes.businessSetting}${buildQueryParameters(searchText, limit, page)}`
    const response = await get(path)
    console.log('RESPONSE: ', { response });

    const { items } = response.data
    businessSettings.value = items

    tableLoading.value = false
  }
  getBusinessSettings(10, 0)

  const submit = async () => {
    formLoad.value = true
    const path = apiRoutes.businessSetting

    if (formId.value !== '') {

      // Update
      await update(path, formId.value, form).then(() => {

        Modal.success({
          title: `¡El registro se ha actualizado exitosamente!`,
        })
        closeModal()
        formLoad.value = false

      }).catch(error => {

        const { errorDescription, errorNumber } = error.response.data
        errorHandler.errorDescription = errorDescription
        errorHandler.errorNumber = errorNumber
        formLoad.value = false

      })

    } else {

      // Create
      await post(path, form).then(() => {

        Modal.success({
          title: `¡El registro se ha almacenado exitosamente!`,
        })
        closeModal()
        formLoad.value = false

      }).catch(error => {

        const { errorDescription, errorNumber } = error.response.data
        errorHandler.errorDescription = errorDescription
        errorHandler.errorNumber = errorNumber

        formLoad.value = false

      })
    }

    await getBusinessSettings(10, 0)
  }

  const deleteRecord = async () => {

    const path = apiRoutes.businessSetting
    const response = await softDelete(path, formId.value)
    if (response) {
      formId.value = ''
      await getBusinessSettings(10, 0)
    }

  }

  return {
    searchText,
    visible,
    formId,
    form,
    formLoad,
    rules,
    businessSettings,
    tableLoading,
    errorHandler,
    ruleForm,

    openModal,
    closeModal,
    getBusinessSettings,
    submit,
    deleteRecord,

    eventOpenModal,
    eventSoftDelete,
  }
}

export default useBusinessSetting

